import axios from 'axios';
import React, { useState } from 'react';
import { API_BASE_URL, NGROK_URL } from '../../utils/const';

const HomeOfficeExpensesCalculator = () => {
  const [formData, setFormData] = useState({
    incomeYear: '',
    occupancyExpenses: '', // for years other than 2022-2023 and 2023-2024
    calculationMethod: '',  // for year 2022-2023
    // Occupancy expenses fields
    rent: '',
    mortgageInterest: '',
    councilRates: '',
    waterRates: '',
    landTaxes: '',
    houseInsurance: '',
    repairs: '',
    otherExpenses: '',
    weeksOwned: '',
    // Apportionment fields
    floorAreaHouse: '',
    floorAreaOffice: '',
    weeksOfficeUsed: '',
    claimFixedRate: '',
    // Fixed rate fields
    hoursUsed: '',
    // Other running expenses
    depreciation: '',
    leasingCosts: '',
    furnitureRepairs: '',
    otherHomeOfficeExpenses: '',
    internetData: '',
    depreciationDecline: '',
    repairsToAssets: '',
    stationeryConsumables: '',
    phone: '',
    cleaningExpenses: '',
    // Actual cost method fields
    electricityMethod: '',
    gasMethod: '',
    cleaning: '',
    furnitureDepreciation: '',
    otherDepreciation: '',
    electricityCostPerUnit: '',
    electricityUnitsPerHour: '',
    electricityHoursUsed: '',
    electricityBillsTotal: '',
    electricityBillsPercentage: '',
    gasBillsTotal: '',
    gasBillsPercentage: '',
    gasCostPerUnit: '',
    gasUnitsPerHour: '',
    gasHoursUsed: '',
    // New field for revised fixed rate
    keepRecords: '',
    internetData: '',
    depreciationDecline: '',
    repairsToAssets: '',
    stationeryConsumables: '',
    phone: '',
    leasingCosts: '',
    cleaningExpenses: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const formatPayload = (formData) => {
    const toNumber = (value) => {
      if (value === '' || value === null || value === undefined) return null;
      const num = parseFloat(value);
      return isNaN(num) ? null : num;
    };

    return {
      target_year: formData.incomeYear,
      occupancy_deduction: formData.occupancyExpenses || "no",
      occ_rent: toNumber(formData.rent),
      occ_mortgage_interest: toNumber(formData.mortgageInterest),
      occ_council_rates: toNumber(formData.councilRates),
      occ_water_rates: toNumber(formData.waterRates),
      occ_land_taxes: toNumber(formData.landTaxes),
      occ_house_insurance: toNumber(formData.houseInsurance),
      occ_other_occ_exp: toNumber(formData.otherExpenses),
      occ_weeks_owned: toNumber(formData.weeksOwned),
      occ_floor_area_house: toNumber(formData.floorAreaHouse),
      occ_floor_area_office: toNumber(formData.floorAreaOffice),
      occ_repairs_office: toNumber(formData.repairs),
      occ_weeks_as_biz: toNumber(formData.weeksOfficeUsed),
      occ_repairs_house_pre2023: null,
      occ_repairs_house_2023: null,
      electricity_method: formData.electricityMethod === 'actual' ? 'actual' : 
                         formData.electricityMethod === 'own-estimate' ? 'estimate' : 'none',
      elec_unit_cost: toNumber(formData.electricityCostPerUnit),
      elec_avg_units_hr: toNumber(formData.electricityUnitsPerHour),
      elec_hours_used: toNumber(formData.electricityHoursUsed),
      elec_total_bills: toNumber(formData.electricityBillsTotal),
      elec_percentage: toNumber(formData.electricityBillsPercentage),
      gas_method: formData.gasMethod || 'none',
      gas_unit_cost: toNumber(formData.gasCostPerUnit),
      gas_avg_units_hr: toNumber(formData.gasUnitsPerHour),
      gas_hours_used: toNumber(formData.gasHoursUsed),
      gas_total_bills: toNumber(formData.gasBillsTotal),
      gas_percentage: toNumber(formData.gasBillsPercentage),
      pre2023_running_expense_method: null,
     run_cleaning: toNumber(formData.cleaning),
    run_dep_furni: toNumber(formData.furnitureDepreciation),
    run_dep_other: toNumber(formData.otherDepreciation),
    run_leasing: toNumber(formData.leasingCosts),
    run_repairs_equip: toNumber(formData.furnitureRepairs),
    run_other: toNumber(formData.otherHomeOfficeExpenses),
      method: formData.calculationMethod === 'revised-fixed-rate' ? 'revised' : 'actual',
      keep_records: formData.keepRecords || "no",
      hours_wfh: toNumber(formData.hoursUsed),
      internet: toNumber(formData.internetData),
      phone: toNumber(formData.phone),
      stationery: toNumber(formData.stationeryConsumables),
      leasing_costs: toNumber(formData.leasingCosts),
      decline_assets: toNumber(formData.depreciationDecline),
      repairs_assets: toNumber(formData.repairsToAssets),
      cleaning: toNumber(formData.cleaningExpenses),
    //   pre2023_running_expense_method: "no",
    };
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        
        try {
          const payload = formatPayload(formData);
          const response = await axios.post(API_BASE_URL+'/ato_calculator/home_office_expenses_calculator', payload);
          setResult(response.data?.home_office_expense_estimate
          );
        } catch (err) {
          setError(err.response?.data?.message || 'An error occurred while calculating expenses');
        } finally {
          setLoading(false);
        }
      };


  // Function to check if selected year is 2022-2023
  const isYear2022_2023 = formData.incomeYear === '2022-23';
  
  // Function to check if selected year is 2023-2024
  const isYear2023_2024 = formData.incomeYear === '2023-24';
  
  // Function to check if we should show the occupancy expenses question
  const shouldShowOccupancyQuestion = formData.incomeYear && !isYear2022_2023 && !isYear2023_2024;

  // Get the year part from the selected income year for display
  const selectedYear = formData.incomeYear ? formData.incomeYear.split('-')[0] : '';

  return (
    <div className="form-container">
      <h1>Home office expenses calculator</h1>
      
      <p>All fields marked with * are mandatory</p>

      <form onSubmit={handleSubmit}>
        {/* Income Year Selector */}
        <div className="form-group">
          <label htmlFor="incomeYear">Income year *</label>
          <select 
            id="incomeYear"
            name="incomeYear"
            value={formData.incomeYear}
            onChange={handleChange}
            className="form-control"
          >
            <option value="">Select</option>
            <option value="2013-14">2013–14</option>
            <option value="2014-15">2014–15</option>
            <option value="2015-16">2015–16</option>
            <option value="2016-17">2016–17</option>
            <option value="2017-18">2017–18</option>
            <option value="2018-19">2018–19</option>
            <option value="2019-20">2019–20</option>
            <option value="2020-21">2020–21</option>
            <option value="2021-22">2021–22</option>
            <option value="2022-23">2022–23</option>
            <option value="2023-24">2023–24</option>
          </select>
        </div>

        {/* Occupancy Expenses Question - Only show for years other than 2022-2023 and 2023-2024 */}
        {shouldShowOccupancyQuestion && (
          <div className="form-group">
            <label>Are you entitled to claim a deduction for occupancy expenses? *</label>
            <div className="radio-group">
              {['yes', 'no'].map((option) => (
                <div key={option} className="radio-option">
                  <input
                    type="radio"
                    id={`occupancy-${option}`}
                    name="occupancyExpenses"
                    value={option}
                    checked={formData.occupancyExpenses === option}
                    onChange={handleChange}
                  />
                  <label htmlFor={`occupancy-${option}`}>
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </label>
                </div>
              ))}
            </div>
          </div>
        )
        
        }

        {/* Calculation Method Question - Only show for year 2022-2023 and 2023-2024 */}
        {(isYear2022_2023 || isYear2023_2024) && (
          <div className="form-group">
            <label>How would you like to calculate your expenses? *</label>
            <div className="radio-group">
              {[
                { value: 'revised-fixed-rate', label: 'Revised fixed rate method' },
                { value: 'actual-cost', label: 'Actual cost method' }
              ].map((option) => (
                <div key={option.value} className="radio-option">
                  <input
                    type="radio"
                    id={`calculation-${option.value}`}
                    name="calculationMethod"
                    value={option.value}
                    checked={formData.calculationMethod === option.value}
                    onChange={handleChange}
                  />
                  <label htmlFor={`calculation-${option.value}`}>{option.label}</label>
                </div>
              ))}

            </div>
            {formData.calculationMethod === 'revised-fixed-rate' && (
              <div className="revised-fixed-rate-form">
                <div className="hours-section">
                  <h3>Revised Fixed Rate - Record of Hours</h3>
                  
                  <div className="form-group">
                    <label>
                      Did you <a href="#">keep records</a> of the actual hours you worked for the entire year? *
                    </label>
                    <p className="info-text">
                      Note: for the period 1 July 2022 to 28 February 2023, records which represent the total hours worked during that period will be accepted.
                    </p>
                    <div className="radio-group">
                      {['yes', 'no'].map((option) => (
                        <div key={option} className="radio-option">
                          <input
                            type="radio"
                            id={`keep-records-${option}`}
                            name="keepRecords"
                            value={option}
                            checked={formData.keepRecords === option}
                            onChange={handleChange}
                            required
                          />
                          <label htmlFor={`keep-records-${option}`}>
                            {option.charAt(0).toUpperCase() + option.slice(1)}
                          </label>
                        </div>
                      ))
                      }{
                        formData.keepRecords === 'yes' && (
                          <div className="form-group ">
                            <label htmlFor="hoursUsed">How many hours did you work? *</label>
                            <input
                              type="text"
                              id="hoursUsed"
                              name="hoursUsed"
                              value={formData.hoursUsed}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        )
                      }
                      {formData.keepRecords === 'no' && (
                        <div className="actual-cost-form">
            <div className="electricity-section">
              <h3>Electricity expenses</h3>
              <label>Choose one of the following methods to calculate electricity expenses *</label>
              <div className="radio-group">
                {[
                  { value: 'actual', label: 'Actual running expenses' },
                  { value: 'own-estimate', label: 'Own estimate' },
                  { value: 'none', label: 'None of the above' }
                ].map((option) => (
                  <div key={option.value} className="radio-option full-width">
                    <input
                      type="radio"
                      id={`electricity-${option.value}`}
                      name="electricityMethod"
                      value={option.value}
                      checked={formData.electricityMethod === option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={`electricity-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>
            {
            formData.electricityMethod === 'own-estimate' && (
              <div className="electricity-own-estimate">
                <div className="expense-item">
                  <label htmlFor="electricityBillsTotal">Total of electricity bills for period of income producing use *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="electricityBillsTotal"
                      name="electricityBillsTotal"
                      value={formData.electricityBillsTotal}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="electricityBillsPercentage">Percentage of electricity bills attributable to home office use *</label>
                  <div className="input-with-suffix input-group">
                    <input
                      type="text"
                      id="electricityBillsPercentage"
                      name="electricityBillsPercentage"
                      value={formData.electricityBillsPercentage}
                      onChange={handleChange}
                      required
                    />
                    <span className="unit">%</span>
                  </div>
                </div>
              </div>
            )}
            {
            formData.electricityMethod === 'actual' && (
              <div className="electricity-actual">
                
                <div className="expense-item">
                  <label htmlFor="electricityCostPerUnit">Cost per unit of electricity used *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="electricityCostPerUnit"
                      name="electricityCostPerUnit"
                      value={formData.electricityCostPerUnit}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="electricityUnitsPerHour">Average units of electricity used per hour for income producing purposes *</label>
                  <input
                    type="text"
                    id="electricityUnitsPerHour"
                    name="electricityUnitsPerHour"
                    value={formData.electricityUnitsPerHour}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="expense-item">
                  <label htmlFor="electricityHoursUsed">Hours of electricity used for income producing purposes during the year *</label>
                  <input
                    type="text"
                    id="electricityHoursUsed"
                    name="electricityHoursUsed"
                    value={formData.electricityHoursUsed}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            )}
            
            <div className="gas-section">
              <h3>Gas expenses</h3>
              <label>Choose one of the following methods to calculate gas expenses *</label>
              <div className="radio-group">
                {[
                  { value: 'actual', label: 'Actual running expenses' },
                  { value: 'own-estimate', label: 'Own estimate' },
                  { value: 'none', label: 'None of the above' }
                ].map((option) => (
                  <div key={option.value} className="radio-option full-width">
                    <input
                      type="radio"
                      id={`gas-${option.value}`}
                      name="gasMethod"
                      value={option.value}
                      checked={formData.gasMethod === option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={`gas-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>
            {
            formData.gasMethod === 'own-estimate' && (
              <div className="gas-own-estimate">
                <div className="expense-item">
                  <label htmlFor="gasBillsTotal">Total of gas bills for period of income producing use *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="gasBillsTotal"
                      name="gasBillsTotal"
                      value={formData.gasBillsTotal}sh
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="gasBillsPercentage">Percentage of gas bills attributable to home office use *</label>
                  <div className="input-with-suffix input-group">
                    <input
                      type="text"
                      id="gasBillsPercentage"
                      name="gasBillsPercentage"
                      value={formData.gasBillsPercentage}
                      onChange={handleChange}
                      required
                    />
                    <span className="unit">%</span>
                  </div>
                </div>
              </div>
            )}
            {
            formData.gasMethod === 'actual' && (
              <div className="gas-actual">
                <div className="info-box">
                  <span className="info-icon">i</span>
                  For more information see <a href="#">Electricity and gas for heating, cooling and lighting</a>
                </div>
                
                <div className="expense-item">
                  <label htmlFor="gasCostPerUnit">Cost per unit of gas used *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="gasCostPerUnit"
                      name="gasCostPerUnit"
                      value={formData.gasCostPerUnit}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="gasUnitsPerHour">Average units of gas used per hour for income producing purposes *</label>
                  <input
                    type="text"
                    id="gasUnitsPerHour"
                    name="gasUnitsPerHour"
                    value={formData.gasUnitsPerHour}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="expense-item">
                  <label htmlFor="gasHoursUsed">Hours of gas used for income producing purposes during the year *</label>
                  <input
                    type="text"
                    id="gasHoursUsed"
                    name="gasHoursUsed"
                    value={formData.gasHoursUsed}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            )}
            
            <div className="other-running-section">
              <h3>Other running expenses - excluding Electricity and Gas</h3>
              <p>Other <a href="#">running expenses</a> are the increased costs of using facilities within your home because of your income earning activities.</p>
              
              <div className="expense-item">
                <label htmlFor="internetData">Internet or data</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="internetData"
                    name="internetData"
                    value={formData.internetData}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="depreciationDecline">Decline in value of depreciating assets</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="depreciationDecline"
                    name="depreciationDecline"
                    value={formData.depreciationDecline}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="repairsToAssets">Repairs to depreciating assets</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="repairsToAssets"
                    name="repairsToAssets"
                    value={formData.repairsToAssets}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="stationeryConsumables">Stationery and computer consumables</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="stationeryConsumables"
                    name="stationeryConsumables"
                    value={formData.stationeryConsumables}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="phone">Phone</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="leasingCosts">Leasing costs</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="leasingCosts"
                    name="leasingCosts"
                    value={formData.leasingCosts}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="cleaningExpenses">Cleaning expenses</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="cleaningExpenses"
                    name="cleaningExpenses"
                    value={formData.cleaningExpenses}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            )}
            {formData?.calculationMethod==='actual-cost' && (
                <div className="actual-cost-form">
            <div className="electricity-section">
              <h3>Electricity expenses</h3>
              <label>Choose one of the following methods to calculate electricity expenses *</label>
              <div className="radio-group">
                {[
                  { value: 'actual', label: 'Actual running expenses' },
                  { value: 'own-estimate', label: 'Own estimate' },
                  { value: 'none', label: 'None of the above' }
                ].map((option) => (
                  <div key={option.value} className="radio-option full-width">
                    <input
                      type="radio"
                      id={`electricity-${option.value}`}
                      name="electricityMethod"
                      value={option.value}
                      checked={formData.electricityMethod === option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={`electricity-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>
            {
            formData.electricityMethod === 'own-estimate' && (
              <div className="electricity-own-estimate">
                <div className="expense-item">
                  <label htmlFor="electricityBillsTotal">Total of electricity bills for period of income producing use *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="electricityBillsTotal"
                      name="electricityBillsTotal"
                      value={formData.electricityBillsTotal}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="electricityBillsPercentage">Percentage of electricity bills attributable to home office use *</label>
                  <div className="input-with-suffix input-group">
                    <input
                      type="text"
                      id="electricityBillsPercentage"
                      name="electricityBillsPercentage"
                      value={formData.electricityBillsPercentage}
                      onChange={handleChange}
                      required
                    />
                    <span className="unit">%</span>
                  </div>
                </div>
              </div>
            )}
            {
            formData.electricityMethod === 'actual' && (
              <div className="electricity-actual">
                
                <div className="expense-item">
                  <label htmlFor="electricityCostPerUnit">Cost per unit of electricity used *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="electricityCostPerUnit"
                      name="electricityCostPerUnit"
                      value={formData.electricityCostPerUnit}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="electricityUnitsPerHour">Average units of electricity used per hour for income producing purposes *</label>
                  <input
                    type="text"
                    id="electricityUnitsPerHour"
                    name="electricityUnitsPerHour"
                    value={formData.electricityUnitsPerHour}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="expense-item">
                  <label htmlFor="electricityHoursUsed">Hours of electricity used for income producing purposes during the year *</label>
                  <input
                    type="text"
                    id="electricityHoursUsed"
                    name="electricityHoursUsed"
                    value={formData.electricityHoursUsed}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            )}
            
            <div className="gas-section">
              <h3>Gas expenses</h3>
              <label>Choose one of the following methods to calculate gas expenses *</label>
              <div className="radio-group">
                {[
                  { value: 'actual', label: 'Actual running expenses' },
                  { value: 'own-estimate', label: 'Own estimate' },
                  { value: 'none', label: 'None of the above' }
                ].map((option) => (
                  <div key={option.value} className="radio-option full-width">
                    <input
                      type="radio"
                      id={`gas-${option.value}`}
                      name="gasMethod"
                      value={option.value}
                      checked={formData.gasMethod === option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={`gas-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>
            {
            formData.gasMethod === 'own-estimate' && (
              <div className="gas-own-estimate">
                <div className="expense-item">
                  <label htmlFor="gasBillsTotal">Total of gas bills for period of income producing use *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="gasBillsTotal"
                      name="gasBillsTotal"
                      value={formData.gasBillsTotal}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="gasBillsPercentage">Percentage of gas bills attributable to home office use *</label>
                  <div className="input-with-suffix input-group">
                    <input
                      type="text"
                      id="gasBillsPercentage"
                      name="gasBillsPercentage"
                      value={formData.gasBillsPercentage}
                      onChange={handleChange}
                      required
                    />
                    <span className="unit">%</span>
                  </div>
                </div>
              </div>
            )}
            {
            formData.gasMethod === 'actual' && (
              <div className="gas-actual">
                <div className="info-box">
                  <span className="info-icon">i</span>
                  For more information see <a href="#">Electricity and gas for heating, cooling and lighting</a>
                </div>
                
                <div className="expense-item">
                  <label htmlFor="gasCostPerUnit">Cost per unit of gas used *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="gasCostPerUnit"
                      name="gasCostPerUnit"
                      value={formData.gasCostPerUnit}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="gasUnitsPerHour">Average units of gas used per hour for income producing purposes *</label>
                  <input
                    type="text"
                    id="gasUnitsPerHour"
                    name="gasUnitsPerHour"
                    value={formData.gasUnitsPerHour}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="expense-item">
                  <label htmlFor="gasHoursUsed">Hours of gas used for income producing purposes during the year *</label>
                  <input
                    type="text"
                    id="gasHoursUsed"
                    name="gasHoursUsed"
                    value={formData.gasHoursUsed}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            )}
            
            <div className="other-running-section">
              <h3>Other running expenses - excluding Electricity and Gas</h3>
              <p>Other <a href="#">running expenses</a> are the increased costs of using facilities within your home because of your income earning activities.</p>
              
              <div className="expense-item">
                <label htmlFor="internetData">Internet or data</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="internetData"
                    name="internetData"
                    value={formData.internetData}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="depreciationDecline">Decline in value of depreciating assets</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="depreciationDecline"
                    name="depreciationDecline"
                    value={formData.depreciationDecline}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="repairsToAssets">Repairs to depreciating assets</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="repairsToAssets"
                    name="repairsToAssets"
                    value={formData.repairsToAssets}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="stationeryConsumables">Stationery and computer consumables</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="stationeryConsumables"
                    name="stationeryConsumables"
                    value={formData.stationeryConsumables}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="phone">Phone</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="leasingCosts">Leasing costs</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="leasingCosts"
                    name="leasingCosts"
                    value={formData.leasingCosts}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="expense-item">
                <label htmlFor="cleaningExpenses">Cleaning expenses</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="cleaningExpenses"
                    name="cleaningExpenses"
                    value={formData.cleaningExpenses}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
            <label>Are you entitled to claim a deduction for occupancy expenses? *</label>
            <div className="radio-group">
              {['yes', 'no'].map((option) => (
                <div key={option} className="radio-option">
                  <input
                    type="radio"
                    id={`occupancy-${option}`}
                    name="occupancyExpenses"
                    value={option}
                    checked={formData.occupancyExpenses === option}
                    onChange={handleChange}
                  />
                  <label htmlFor={`occupancy-${option}`}>
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </label>
                </div>
              ))}
            </div>
          </div>
          {formData?.occupancyExpenses==='yes'&&(<div className="expenses-section">
              <h2>Occupancy expenses</h2>
              <p>Enter the total expenses incurred in {selectedYear}</p>
              
              <div className="expense-item">
                <label htmlFor="rent">Rent</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="rent"
                    name="rent"
                    value={formData.rent}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="mortgageInterest">Mortgage interest</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="mortgageInterest"
                    name="mortgageInterest"
                    value={formData.mortgageInterest}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="councilRates">Council rates</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="councilRates"
                    name="councilRates"
                    value={formData.councilRates}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="waterRates">Water rates</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="waterRates"
                    name="waterRates"
                    value={formData.waterRates}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="landTaxes">Land taxes</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="landTaxes"
                    name="landTaxes"
                    value={formData.landTaxes}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="houseInsurance">House insurance premiums</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="houseInsurance"
                    name="houseInsurance"
                    value={formData.houseInsurance}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="repairs">Repairs that relate to the house as a whole (e.g. roofing). Do not enter repairs that relate to a specific part of the house (e.g. home office)</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="repairs"
                    name="repairs"
                    value={formData.repairs}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="otherExpenses">Other occupancy expenses (Do not include gas and electricity)</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="otherExpenses"
                    name="otherExpenses"
                    value={formData.otherExpenses}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item input-group">
                <label htmlFor="weeksOwned">Number of weeks you owned the property during the year *</label>
                <input
                  type="text"
                  id="weeksOwned"
                  name="weeksOwned"
                  className="input-group"
                  value={formData.weeksOwned}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>)}
          </div>
            
            
            )
            
            }
          </div>
        )}

        {/* Occupancy Expenses Form - Show when occupancyExpenses is "yes" */}
        {shouldShowOccupancyQuestion && formData.occupancyExpenses === 'yes' && (
          <>
            {/* Occupancy Expenses Section */}
            <div className="expenses-section">
              <h2>Occupancy expenses</h2>
              <p>Enter the total expenses incurred in {selectedYear}</p>
              
              <div className="expense-item">
                <label htmlFor="rent">Rent</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="rent"
                    name="rent"
                    value={formData.rent}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="mortgageInterest">Mortgage interest</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="mortgageInterest"
                    name="mortgageInterest"
                    value={formData.mortgageInterest}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="councilRates">Council rates</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="councilRates"
                    name="councilRates"
                    value={formData.councilRates}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="waterRates">Water rates</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="waterRates"
                    name="waterRates"
                    value={formData.waterRates}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="landTaxes">Land taxes</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="landTaxes"
                    name="landTaxes"
                    value={formData.landTaxes}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="houseInsurance">House insurance premiums</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="houseInsurance"
                    name="houseInsurance"
                    value={formData.houseInsurance}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="repairs">Repairs that relate to the house as a whole (e.g. roofing). Do not enter repairs that relate to a specific part of the house (e.g. home office)</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="repairs"
                    name="repairs"
                    value={formData.repairs}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="otherExpenses">Other occupancy expenses (Do not include gas and electricity)</label>
                <div className="input-with-prefix input-group">
                  <span className="currency-symbol">$</span>
                  <input
                    type="text"
                    id="otherExpenses"
                    name="otherExpenses"
                    value={formData.otherExpenses}
                    onChange={handleChange}
                  />
                </div>
              </div>
              
              <div className="expense-item input-group">
                <label htmlFor="weeksOwned">Number of weeks you owned the property during the year *</label>
                <input
                  type="text"
                  id="weeksOwned"
                  name="weeksOwned"
                  className="input-group"
                  value={formData.weeksOwned}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Apportionment Section */}
            <div className="apportionment-section">
              <h2>Apportionment</h2>
              <p>Enter your details below for Occupancy expenses – apportionment</p>
              
              <div className="expense-item">
                <label htmlFor="floorAreaHouse">Floor area of your house *</label>
                <div className="input-with-suffix input-group">
                  <input
                    type="text"
                    id="floorAreaHouse"
                    name="floorAreaHouse"
                    value={formData.floorAreaHouse}
                    onChange={handleChange}
                    required
                  />
                  <span className="unit">m<sup>2</sup></span>
                </div>
              </div>
              
              <div className="expense-item">
                <label htmlFor="floorAreaOffice">Floor area of your home office *</label>
                <div className="input-with-suffix input-group">
                  <input
                    type="text"
                    id="floorAreaOffice"
                    name="floorAreaOffice"
                    value={formData.floorAreaOffice}
                    onChange={handleChange}
                    required
                  />
                  <span className="unit">m<sup>2</sup></span>
                </div>
              </div>
              
              <div className="expense-item input-group">
                <label htmlFor="weeksOfficeUsed">Number of weeks during the year your home office was a 'place of business' *</label>
                <input
                  type="text"
                  id="weeksOfficeUsed"
                  name="weeksOfficeUsed"
                  value={formData.weeksOfficeUsed}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            
          </>
        
        )}

         {/* Running Expenses Section - Always show this section */}
        {(shouldShowOccupancyQuestion && formData.occupancyExpenses!=="") && <section>
         <div className="running-expenses-section">
          <h2>Calculate running expenses</h2>
          <p>There are two ways to calculate your running expenses; you can claim a <a href="#">fixed rate</a> of 34 cents per hour or you can calculate your <a href="#">actual expenses</a>.</p>
        </div>

        {/* Fixed Rate Section - Always show this part */}
        <div className="fixed-rate-section">
          <h3>Fixed rate</h3>
          <label>Do you want to claim a deduction of 34c per hour based on actual use or an established pattern of use? *</label>
          <div className="radio-group">
            <div className="radio-option fixed-rate-option">
              <input
                type="radio"
                id="fixed-rate-yes"
                name="claimFixedRate"
                value="yes"
                checked={formData.claimFixedRate === 'yes'}
                onChange={handleChange}
              />
              <label htmlFor="fixed-rate-yes">Yes</label>
            </div>
            <div className="radio-option fixed-rate-option">
              <input
                type="radio"
                id="fixed-rate-no"
                name="claimFixedRate"
                value="no"
                checked={formData.claimFixedRate === 'no'}
                onChange={handleChange}
              />
              <label htmlFor="fixed-rate-no">No</label>
            </div>
          </div>
        </div>
        
        {/* Show different forms based on claimFixedRate selection */}
        {formData.claimFixedRate === 'yes' && (
          <div className="fixed-rate-form">
            <div className="hours-section">
              <h3>Hours of operation</h3>
              <label htmlFor="hoursUsed">How many hours during the year did you use the home office for income producing purposes? *</label>
              <input
                type="text"
                id="hoursUsed"
                name="hoursUsed"
                value={formData.hoursUsed}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="other-running-section">
  <h3>Other running expenses</h3>
  <p>Other <a href="#">running expenses</a> are the increased costs of using facilities within your home because of your business activities.</p>
  
  <div className="expense-item">
    <label htmlFor="cleaning">Cleaning</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="cleaning"
        name="cleaning"
        value={formData.cleaning}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="furnitureDepreciation">Depreciation – furniture</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="furnitureDepreciation"
        name="furnitureDepreciation"
        value={formData.furnitureDepreciation}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="otherDepreciation">Depreciation – other than furniture</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="otherDepreciation"
        name="otherDepreciation"
        value={formData.otherDepreciation}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="leasingCosts">Leasing costs</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="leasingCosts"
        name="leasingCosts"
        value={formData.leasingCosts}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="furnitureRepairs">Repairs to office furniture and equipment</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="furnitureRepairs"
        name="furnitureRepairs"
        value={formData.furnitureRepairs}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="otherHomeOfficeExpenses">Other home office running expenses</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="otherHomeOfficeExpenses"
        name="otherHomeOfficeExpenses"
        value={formData.otherHomeOfficeExpenses}
        onChange={handleChange}
      />
    </div>
  </div>
</div>
          </div>
        )}
        
        {formData.claimFixedRate === 'no' && (
          <div className="actual-cost-form">
            <div className="electricity-section">
              <h3>Electricity expenses</h3>
              <label>Choose one of the following methods to calculate electricity expenses *</label>
              <div className="radio-group">
                {[
                  { value: 'actual', label: 'Actual running expenses' },
                  { value: 'own-estimate', label: 'Own estimate' },
                  { value: 'none', label: 'None of the above' }
                ].map((option) => (
                  <div key={option.value} className="radio-option full-width">
                    <input
                      type="radio"
                      id={`electricity-${option.value}`}
                      name="electricityMethod"
                      value={option.value}
                      checked={formData.electricityMethod === option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={`electricity-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>
            {
            formData.electricityMethod === 'own-estimate' && (
              <div className="electricity-own-estimate">
                <div className="expense-item">
                  <label htmlFor="electricityBillsTotal">Total of electricity bills for period of income producing use *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="electricityBillsTotal"
                      name="electricityBillsTotal"
                      value={formData.electricityBillsTotal}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="electricityBillsPercentage">Percentage of electricity bills attributable to home office use *</label>
                  <div className="input-with-suffix input-group">
                    <input
                      type="text"
                      id="electricityBillsPercentage"
                      name="electricityBillsPercentage"
                      value={formData.electricityBillsPercentage}
                      onChange={handleChange}
                      required
                    />
                    <span className="unit">%</span>
                  </div>
                </div>
              </div>
            )}
            {
            formData.electricityMethod === 'actual' && (
              <div className="electricity-actual">
                
                <div className="expense-item">
                  <label htmlFor="electricityCostPerUnit">Cost per unit of electricity used *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="electricityCostPerUnit"
                      name="electricityCostPerUnit"
                      value={formData.electricityCostPerUnit}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="electricityUnitsPerHour">Average units of electricity used per hour for income producing purposes *</label>
                  <input
                    type="text"
                    id="electricityUnitsPerHour"
                    name="electricityUnitsPerHour"
                    value={formData.electricityUnitsPerHour}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="expense-item">
                  <label htmlFor="electricityHoursUsed">Hours of electricity used for income producing purposes during the year *</label>
                  <input
                    type="text"
                    id="electricityHoursUsed"
                    name="electricityHoursUsed"
                    value={formData.electricityHoursUsed}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            )}
            
            <div className="gas-section">
              <h3>Gas expenses</h3>
              <label>Choose one of the following methods to calculate gas expenses *</label>
              <div className="radio-group">
                {[
                  { value: 'actual', label: 'Actual running expenses' },
                  { value: 'own-estimate', label: 'Own estimate' },
                  { value: 'none', label: 'None of the above' }
                ].map((option) => (
                  <div key={option.value} className="radio-option full-width">
                    <input
                      type="radio"
                      id={`gas-${option.value}`}
                      name="gasMethod"
                      value={option.value}
                      checked={formData.gasMethod === option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={`gas-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>
            {
            formData.gasMethod === 'own-estimate' && (
              <div className="gas-own-estimate">
                <div className="expense-item">
                  <label htmlFor="gasBillsTotal">Total of gas bills for period of income producing use *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="gasBillsTotal"
                      name="gasBillsTotal"
                      value={formData.gasBillsTotal}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="gasBillsPercentage">Percentage of gas bills attributable to home office use *</label>
                  <div className="input-with-suffix input-group">
                    <input
                      type="text"
                      id="gasBillsPercentage"
                      name="gasBillsPercentage"
                      value={formData.gasBillsPercentage}
                      onChange={handleChange}
                      required
                    />
                    <span className="unit">%</span>
                  </div>
                </div>
              </div>
            )}
            {
            formData.gasMethod === 'actual' && (
              <div className="gas-actual">
                <div className="info-box">
                  <span className="info-icon">i</span>
                  For more information see <a href="#">Electricity and gas for heating, cooling and lighting</a>
                </div>
                
                <div className="expense-item">
                  <label htmlFor="gasCostPerUnit">Cost per unit of gas used *</label>
                  <div className="input-with-prefix input-group">
                    <span className="currency-symbol">$</span>
                    <input
                      type="text"
                      id="gasCostPerUnit"
                      name="gasCostPerUnit"
                      value={formData.gasCostPerUnit}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="expense-item">
                  <label htmlFor="gasUnitsPerHour">Average units of gas used per hour for income producing purposes *</label>
                  <input
                    type="text"
                    id="gasUnitsPerHour"
                    name="gasUnitsPerHour"
                    value={formData.gasUnitsPerHour}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="expense-item">
                  <label htmlFor="gasHoursUsed">Hours of gas used for income producing purposes during the year *</label>
                  <input
                    type="text"
                    id="gasHoursUsed"
                    name="gasHoursUsed"
                    value={formData.gasHoursUsed}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            )}
            
            <div className="other-running-section">
  <h3>Other running expenses</h3>
  <p>Other <a href="#">running expenses</a> are the increased costs of using facilities within your home because of your business activities.</p>
  
  <div className="expense-item">
    <label htmlFor="cleaning">Cleaning</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="cleaning"
        name="cleaning"
        value={formData.cleaning}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="furnitureDepreciation">Depreciation – furniture</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="furnitureDepreciation"
        name="furnitureDepreciation"
        value={formData.furnitureDepreciation}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="otherDepreciation">Depreciation – other than furniture</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="otherDepreciation"
        name="otherDepreciation"
        value={formData.otherDepreciation}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="leasingCosts">Leasing costs</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="leasingCosts"
        name="leasingCosts"
        value={formData.leasingCosts}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="furnitureRepairs">Repairs to office furniture and equipment</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="furnitureRepairs"
        name="furnitureRepairs"
        value={formData.furnitureRepairs}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="expense-item">
    <label htmlFor="otherHomeOfficeExpenses">Other home office running expenses</label>
    <div className="input-with-prefix input-group">
      <span className="currency-symbol">$</span>
      <input
        type="text"
        id="otherHomeOfficeExpenses"
        name="otherHomeOfficeExpenses"
        value={formData.otherHomeOfficeExpenses}
        onChange={handleChange}
      />
    </div>
  </div>
</div>
          </div>
        )}
        </section>}

       
        
        {/* Home Office Expenses Summary - Always show */}
        {/* <div className="expenses-summary">
          <div className="summary-header">
            <h2>Home office expenses</h2>
            <button type="button" className="estimate-button">Estimate</button>
          </div>
        </div> */}

        <div className="form-group submit-group">
  {error && (
    <div className='error'>
      <p>{error}</p>
    </div>
  )}

  {result && (
    <div className='result-container'>
      <h2>Calculation Results</h2>
      <div className="result-summary">
        <p>Total Deductible Amount: {result}</p>
        {/* Add more result fields as needed */}
      </div>
    </div>
  )}

  {loading && (
    <div className='loading-container'>
      <div className='spinner'></div>
      <p>Calculating your home office expenses...</p>
    </div>
  )}
  
  <button type="submit" className="submit-button" disabled={loading}>
    {loading ? 'Calculating...' : 'Calculate Tax Estimate'}
  </button>
</div>
      </form>
    </div>
  );
};

export default HomeOfficeExpensesCalculator;